module.exports = global["ReactDOM"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 530
// module chunks = 0